import { CustomReportDashboardModules } from "shared/components/pillar-table/custom-reports/CustomReportDashboardModules";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";

export interface PillarTableHeaderBarProps {
  children?: React.ReactNode | (() => React.ReactNode);
  className?: string;
}

const PillarTableHeaderBar = ({
  children,
  className,
}: PillarTableHeaderBarProps) => {
  const childContent = typeof children === "function" ? children() : children;

  return (
    <>
      <div
        className={`flex justify-between w-full gap-1 ${className ? className : ""}`}
      >
        {childContent}
      </div>
      <CustomReportDashboardModules />
    </>
  );
};

export default PillarTableHeaderBar;
